export interface AutoCompleteRecipeData {
  query?: string;
  ingredient: {
    field: string;
    values: string[];
  };
  recipe: {
    field: string;
    values: string[];
  };
}
export interface AcpResponseAPI {
  query?: string;
  fieldFilters?: {
    ingredient: {
      field: string;
      values: string[];
    };
    recipe: {
      field: string;
      values: string[];
    };
  };
}

export enum RecipeSearchType {
  INGREDIENT = 'RECIPE_ACP.INGREDIENTS',
  RECIPE = 'RECIPE_ACP.RECIPES',
}

export enum RecipeSearchField {
  INGREDIENT = 'ingredient',
  RECIPE = 'recipe',
}
